import { createAction } from 'redux-actions';

export const types = {
  findVisitorsWithCriminalRecordSuccess:
    'findVisitorsWithCriminalRecordSuccess',
  findVisitorsWithCriminalRecordInProgress:
    'findVisitorsWithCriminalRecordInProgress',
  findVisitorsWithCriminalRecordFailed: 'findVisitorsWithCriminalRecordFailed'
};

const findVisitorsWithCriminalRecordInProgress = createAction(
  types.findVisitorsWithCriminalRecordInProgress
);
const findVisitorsWithCriminalRecordSuccess = createAction(
  types.findVisitorsWithCriminalRecordSuccess
);
const findVisitorsWithCriminalRecordFailed = createAction(
  types.findVisitorsWithCriminalRecordFailed
);

const findVisitorsWithCriminalRecord = query => {
  return (dispatch, getState, Api) => {
    dispatch(findVisitorsWithCriminalRecordInProgress());

    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;

    return crowdModule
      .findVisitorsWithCriminalRecord(query)
      .then(response => {
        dispatch(findVisitorsWithCriminalRecordSuccess(response));
      })
      .catch(error => {
        dispatch(
          findVisitorsWithCriminalRecordFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

/**
 * Respuesta del PUT (texto): { visitorId, firstName, lastName, nameMatches } o
 * null (crowd viejo respondía 204 vacío).
 */
export const parseSavedRecord = body => {
  if (!body || typeof body !== 'string') {
    return body && typeof body === 'object' ? body : null;
  }
  try {
    return JSON.parse(body);
  } catch (error) {
    return null;
  }
};

const updateOrCreateCriminalRecord = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    return crowdModule
      .updateOrCreateCriminalRecord(query)
      .then(parseSavedRecord);
  };
};

const deleteCriminalRecord = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    return crowdModule.deleteCriminalRecordByVisitorId(query);
  };
};

const uploadFile = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    return crowdModule.uploadPdf(query);
  };
};

export const CriminalRecordActions = {
  findVisitorsWithCriminalRecord,
  updateOrCreateCriminalRecord,
  deleteCriminalRecord,
  uploadFile
};
